import { inject, Injectable, signal } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UserSummary } from '../client-api.service';
import { UserInfo } from '../auth/UserInfo';



/** The time in ms to store users results. */
const BUFFER_TIME = 3600000;

@Injectable({
  providedIn: 'root'
})
export class UserService {

  authSvc = inject(AuthService);

  userInfo = signal<UserInfo | null>(null);
  
  curremntUserName = signal<string | undefined>(undefined);
}